import './bootstrap';
import { createApp } from 'vue';
import { createVuetify } from 'vuetify';
import * as directives from 'vuetify/directives';
import * as components from 'vuetify/components';
const vuetify = createVuetify({ components, directives });
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css'
import '../sass/app.scss';

// import HeaderComponent from './components/HeaderComponent.vue';
// import permissions from "./Permissions.js";

window.addEventListener('load', function() {
    const base = {
        components: {
            // HeaderComponent,
        },
    };

    const app = createApp(base);
    app.use(vuetify);
    // app.mixin(permissions);
    app.mount('#app');
})

// 以下、旧アプリでの記述、読み込み時にrequireがエラーになっていたため一旦コメントアウトし上記で対応
// /**
//  * First we will load all of this project's JavaScript dependencies which
//  * includes Vue and other libraries. It is a great starting point when
//  * building robust, powerful web applications using Vue and Laravel.
//  */

// require('./bootstrap');

// window.Vue = require('vue').default;

// /**
//  * The following block of code may be used to automatically register your
//  * Vue components. It will recursively scan this directory for the Vue
//  * components and automatically register them with their "basename".
//  *
//  * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
//  */

// // const files = require.context('./', true, /\.vue$/i)
// // files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

// /**
//  * Next, we will create a fresh Vue application instance and attach it to
//  * the page. Then, you may begin adding components to this application
//  * or customize the JavaScript scaffolding to fit your unique needs.
//  */

// const app = new Vue({
//     el: '#app',
// });
